<app-header></app-header>

<div class="container-fluid" style="width: 80%; min-height: 600px">
  <div class="row mt-4 mb-4">
    <div class="col">
      <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
        <ol class="breadcrumb mb-0 p-0">
          <li class="breadcrumb-item"><a href="/home">Home</a><span class="separator">/</span></li>
          <li class="breadcrumb-item active" aria-current="page">Operatori</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col">
      <h4>Operatori (utenti WSO2)</h4>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-header class="d-flex justify-content-between align-items-center">
          <mat-card-title>Elenco utenti</mat-card-title>
          <button mat-raised-button color="primary" (click)="apriNuovoUtente()">Aggiungi utente</button>
        </mat-card-header>
        <mat-card-content>
          @if (usersLoading) {
            <div class="d-flex justify-content-center p-3">
              <mat-spinner diameter="40"></mat-spinner>
            </div>
          } @else if (usersError) {
            <p class="text-danger mb-0">{{ usersError }}</p>
          } @else {
            <table mat-table [dataSource]="users" class="w-100">
              <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef>Username</th>
                <td mat-cell *matCellDef="let u">{{ u.username }}</td>
              </ng-container>
              <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef>Nome</th>
                <td mat-cell *matCellDef="let u">{{ u.nome }}</td>
              </ng-container>
              <ng-container matColumnDef="cognome">
                <th mat-header-cell *matHeaderCellDef>Cognome</th>
                <td mat-cell *matCellDef="let u">{{ u.cognome }}</td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let u">{{ u.email || '—' }}</td>
              </ng-container>
              <ng-container matColumnDef="dettaglio">
                <th mat-header-cell *matHeaderCellDef>Dettaglio</th>
                <td mat-cell *matCellDef="let u">
                  <button mat-button (click)="dettaglioUtente(u)">Dettaglio</button>
                </td>
              </ng-container>
              <ng-container matColumnDef="cot">
                <th mat-header-cell *matHeaderCellDef>COT</th>
                <td mat-cell *matCellDef="let u">
                  <button mat-button color="primary" (click)="collegaCot(u)">Collega COT</button>
                </td>
              </ng-container>
              <ng-container matColumnDef="tipoSegnalazione">
                <th mat-header-cell *matHeaderCellDef>Tipi segnalazione</th>
                <td mat-cell *matCellDef="let u">
                  <button mat-button color="primary" (click)="gestisciTipiSegnalazione(u)">Gestisci tipi segnalazione</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<app-footer></app-footer>
